import { defineStore } from 'pinia'

export const useAuditStore = defineStore('audit', {
    state: () => ({
        audit_medicines:[],
    }),
    actions: {
        save_data(id) {
            if (this.audit_medicines.includes(id) == false) {
                this.audit_medicines.push(id);
            }
        },
        delete_data(id) {
            for (let i=0;i<this.audit_medicines.length;i++) {
                if (this.audit_medicines[i] == id) {
                    this.audit_medicines.splice(i,1);
                    break;
                }
            }
        },
        reset_data() {
            this.audit_medicines.splice(0);
        }
    },
    persist: true,
})
